import React from 'react'
import PropTypes from 'prop-types';
import Parent from 'pu-react/components/PriceMatrixCell'
import RadioComponent from 'pu-react/components/RadioComponent';

// Overridden to make the quantity either a string or a number
class PriceMatrixCell extends Parent {
  renderInput() {
    return (
      <RadioComponent
        inputId={`price-${this.identifier()}`}
        label={this.showUnitPrice()}
        name={this.props.name}
        onChange={this.onChange}
        inputClassName={this.props.inputClassName}
        checked={this.isSelected()}
        groupName="parameters[mx_pcb_assembly]" />
    );
  }
 }

PriceMatrixCell.propTypes = {
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default PriceMatrixCell
